import { CuffaAPI } from "api/cuffa/cuffa.api";
import { create } from "zustand";

interface CuffaPagination {
  currentPage: number;
  skip: number;
  take: number;
  total: number;
  totalPages: number;
}

interface CuffaListStore {
  cuffaList: any[];
  cuffaFilters: {
    institution_uuid: string;
    cpf: string;
    family_unit_name: string;
  };
  cuffaPagination: CuffaPagination;
  setCuffaFilters: (cuffaFilters: any) => void;
  setCuffaList: (cuffaList: any[]) => void;
  getCuffaList: () => void;
  setCuffaPagination: (cuffaPagination: any) => void;
  clearFiltersAndGetCuffaList: () => void;
  switchPage: (page: number) => void;
}

const useCuffaListStore = create<CuffaListStore>((set, get) => ({
  cuffaList: [],
  cuffaFilters: {
    institution_uuid: '',
    cpf: '',
    family_unit_name: ''
  },
  cuffaPagination: {
    currentPage: 1,
    skip: 0,
    take: 10,
    total: 0,
    totalPages: 1
  },
  setCuffaFilters: (cuffaFilters: any) => set({ cuffaFilters }),
  setCuffaPagination: (cuffaPagination: any) => set({ cuffaPagination }),
  setCuffaList: (cuffaList: any[]) => set({ cuffaList }),
  getCuffaList: async () => {
    const response: any = (await CuffaAPI.listar(get().cuffaFilters, get().cuffaPagination)).dados;
    const collections = response.collections;
    const pagination = response.pagination;
    set({ cuffaList: collections, cuffaPagination: pagination });
  },
  clearFiltersAndGetCuffaList: async () => {
    set({ cuffaFilters: { cpf: '', family_unit_name: '', institution_uuid: '' } });
    const response: any = (await CuffaAPI.listar(get().cuffaFilters, get().cuffaPagination)).dados;
    const collections = response.collections;
    const pagination = response.pagination;
    set({ cuffaList: collections, cuffaPagination: pagination });
  },
  switchPage: (page: number) => {
    if (page < 0 || page > get().cuffaPagination.totalPages) {
      console.log('page', page);
      if (get().cuffaPagination.totalPages > 0) {
        alert('Página inválida');
        return;
      }
    }
    set({ cuffaPagination: { ...get().cuffaPagination, currentPage: page } });
    get().getCuffaList();
  }
}));

export default useCuffaListStore;
